/**
 * Device Compatibility Modal
 * Replaces the bulky #esim-compatibility section with a clean button + modal.
 * Reads device data from the existing hidden DOM section.
 */
(function() {
  'use strict';

  var section = document.getElementById('esim-compatibility');
  if (!section) return;

  // ── 1. Extract device data from existing DOM ──
  var deviceData = [];
  var accordions = section.querySelectorAll('.accordion-item');

  accordions.forEach(function(acc) {
    var headerEl = acc.querySelector('.accordion-header span');
    if (!headerEl) return;
    var brandGroup = headerEl.textContent.trim();
    var tabs = acc.querySelectorAll('.tab-btn');
    var panes = acc.querySelectorAll('.tab-pane');

    tabs.forEach(function(tab, i) {
      var category = tab.textContent.trim();
      if (!panes[i]) return;
      var items = panes[i].querySelectorAll('li');
      items.forEach(function(li) {
        deviceData.push({
          group: brandGroup,
          category: category,
          name: li.textContent.trim()
        });
      });
    });
  });

  // ── 2. Hide original section, inject button above "Ask a question / Share" ──
  section.style.display = 'none';

  var btnWrap = document.createElement('div');
  btnWrap.className = 'dc-button-wrap';
  btnWrap.innerHTML =
    '<button type="button" class="dc-check-btn" id="dc-open-modal">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        '<rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>' +
        '<line x1="12" y1="18" x2="12.01" y2="18"/>' +
      '</svg>' +
      '<span>Check Device Compatibility</span>' +
      '<svg class="dc-btn-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
        '<polyline points="9 18 15 12 9 6"/>' +
      '</svg>' +
    '</button>';

  // Insert above "Ask a question / Share" block
  var addonsBlock = document.querySelector('.main-product__block-addons');
  if (addonsBlock) {
    addonsBlock.parentNode.insertBefore(btnWrap, addonsBlock);
  } else {
    // Fallback: insert after the original hidden section
    var parentShopifySection = section.closest('.shopify-section');
    if (parentShopifySection) {
      parentShopifySection.appendChild(btnWrap);
    } else {
      section.parentNode.insertBefore(btnWrap, section.nextSibling);
    }
  }

  // ── 3. Build modal HTML ──
  var categories = [];
  var catMap = {};
  deviceData.forEach(function(d) {
    var key = d.group + '|' + d.category;
    if (!catMap[key]) {
      catMap[key] = { group: d.group, category: d.category, devices: [] };
      categories.push(catMap[key]);
    }
    catMap[key].devices.push(d.name);
  });

  // Group by brand group (Apple / Android)
  var groups = {};
  categories.forEach(function(cat) {
    if (!groups[cat.group]) groups[cat.group] = [];
    groups[cat.group].push(cat);
  });

  var brandListHTML = '';
  Object.keys(groups).forEach(function(groupName) {
    var cats = groups[groupName];
    cats.forEach(function(cat) {
      var icon = '';
      if (cat.category === 'iPhone' || cat.category === 'iPad' || cat.category === 'Watch') {
        icon = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1.5"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83"/><path d="M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11"/></svg>';
      } else if (cat.category === 'Samsung') {
        icon = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1.5"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>';
      } else if (cat.category === 'Google') {
        icon = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/><path d="M2 12h20"/></svg>';
      } else {
        icon = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1.5"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>';
      }

      var devicesHTML = cat.devices.map(function(d) {
        return '<li class="dc-device-item" data-name="' + d.toLowerCase() + '">' + d + '</li>';
      }).join('');

      brandListHTML +=
        '<div class="dc-brand-group" data-brand="' + cat.category.toLowerCase() + '">' +
          '<button type="button" class="dc-brand-header">' +
            '<div class="dc-brand-left">' +
              icon +
              '<span class="dc-brand-name">' + cat.category + '</span>' +
              '<span class="dc-device-count">' + cat.devices.length + ' devices</span>' +
            '</div>' +
            '<svg class="dc-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>' +
          '</button>' +
          '<div class="dc-brand-devices">' +
            '<ul class="dc-device-list">' + devicesHTML + '</ul>' +
          '</div>' +
        '</div>';
    });
  });

  var modal = document.createElement('div');
  modal.id = 'dc-modal';
  modal.className = 'dc-modal';
  modal.innerHTML =
    '<div class="dc-modal-overlay"></div>' +
    '<div class="dc-modal-container">' +
      '<div class="dc-modal-header">' +
        '<h3>Device Compatibility</h3>' +
        '<button type="button" class="dc-modal-close" aria-label="Close">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="dc-modal-search">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
        '<input type="text" id="dc-search-input" placeholder="Search your device..." autocomplete="off">' +
        '<button type="button" class="dc-search-clear" id="dc-search-clear" style="display:none;">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
      '</div>' +
      '<p class="dc-hint">Tip: Dial <strong>*#06#</strong> on your phone. If an EID appears, your device supports eSIM.</p>' +
      '<div class="dc-modal-body">' +
        brandListHTML +
        '<div class="dc-no-results" style="display:none;">No matching devices found</div>' +
      '</div>' +
    '</div>';

  document.body.appendChild(modal);

  // ── 4. Event handlers ──
  var openBtn = document.getElementById('dc-open-modal');
  var closeBtn = modal.querySelector('.dc-modal-close');
  var overlay = modal.querySelector('.dc-modal-overlay');
  var searchInput = document.getElementById('dc-search-input');
  var searchClear = document.getElementById('dc-search-clear');
  var brandHeaders = modal.querySelectorAll('.dc-brand-header');
  var noResults = modal.querySelector('.dc-no-results');

  function openModal() {
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    setTimeout(function() { searchInput.focus(); }, 300);
  }

  function closeModal() {
    modal.classList.remove('active');
    document.body.style.overflow = '';
    searchInput.value = '';
    searchClear.style.display = 'none';
    resetSearch();
  }

  openBtn.addEventListener('click', openModal);
  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('active')) closeModal();
  });

  // Brand accordion toggle
  brandHeaders.forEach(function(header) {
    header.addEventListener('click', function() {
      var group = header.closest('.dc-brand-group');
      var isOpen = group.classList.contains('open');
      // Close all
      modal.querySelectorAll('.dc-brand-group.open').forEach(function(g) {
        g.classList.remove('open');
      });
      // Toggle current
      if (!isOpen) group.classList.add('open');
    });
  });

  // Search functionality
  function resetSearch() {
    var allGroups = modal.querySelectorAll('.dc-brand-group');
    allGroups.forEach(function(g) {
      g.style.display = '';
      g.classList.remove('open');
      g.querySelectorAll('.dc-device-item').forEach(function(item) {
        item.style.display = '';
      });
    });
    noResults.style.display = 'none';
  }

  var searchTimeout;
  searchInput.addEventListener('input', function() {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(function() {
      var query = searchInput.value.trim().toLowerCase();
      searchClear.style.display = query ? 'flex' : 'none';

      if (!query) {
        resetSearch();
        return;
      }

      var hasAny = false;
      var allGroups = modal.querySelectorAll('.dc-brand-group');

      allGroups.forEach(function(group) {
        var items = group.querySelectorAll('.dc-device-item');
        var groupHasMatch = false;

        items.forEach(function(item) {
          var name = item.getAttribute('data-name');
          if (name.indexOf(query) !== -1) {
            item.style.display = '';
            groupHasMatch = true;
          } else {
            item.style.display = 'none';
          }
        });

        if (groupHasMatch) {
          group.style.display = '';
          group.classList.add('open');
          hasAny = true;
        } else {
          group.style.display = 'none';
        }
      });

      noResults.style.display = hasAny ? 'none' : 'block';
    }, 150);
  });

  searchClear.addEventListener('click', function() {
    searchInput.value = '';
    searchClear.style.display = 'none';
    resetSearch();
    searchInput.focus();
  });
})();
